import { FC } from 'react';
import { FieldAttributes } from 'formik';
import { BotaoFlat } from '../Botao/Botao';
import { Situacao, Situacoes, TransicaoSituacao, TransicaoSituacaoComplexa } from 'model/solicitacao/Situacao';

import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { useAutorizacao } from '../Autorizacao/useAutorizacao';
import { useState } from 'react';
import { ConfirmacaoMudancaSituacaoModal } from './ConfirmacaoMudancaSituacaoModal';
import { useSelector } from 'react-redux';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';


interface Props extends FieldAttributes<any> {
  solicitacao: SolicitacaoDetalhada
  alterarSituacao: (situacao: Situacao) => void
}


export const SituacaoBotoesField: FC<Props> = ({alterarSituacao, solicitacao, ...props}) => {
  const autorizacao = useAutorizacao();
  const [situacaoClicada, setSituacaoClicada] = useState<Situacao|undefined>(undefined);

  const situacaoAtual = solicitacao.situacao ?? Situacoes.NAO_DEFINIDA;

  const submit = async (situacao: Situacao) => {
    // FIXME: Forma mais elegante de identificar qual botão foi selecionado e está carregando
    setSituacaoClicada(situacao);
    try {
      await alterarSituacao(situacao);
    } catch (e) {
      setSituacaoClicada(undefined);
      throw e;
    }
  }
  
  const transicoes = new TransicaoSituacao(autorizacao).by(situacaoAtual);

  const botoes = transicoes.map(it =>
    <SituacaoBotaoByTransicao 
      key={it.destino.id}
      transicao={it}
      submit={submit}
      situacaoClicada={situacaoClicada} />
  );

  return <div className={props.className}>{botoes}</div>;
}


interface SituacaoBotaoByTransicaoProps {
  transicao: TransicaoSituacaoComplexa;
  submit: (situacao: Situacao) => void;
  situacaoClicada?: Situacao
}

const SituacaoBotaoByTransicao: FC<SituacaoBotaoByTransicaoProps> = ({transicao, submit, situacaoClicada}) => {
  const [isAberto, setAberto] = useState<boolean>(false);
  const isNecessarioConfirmacao = transicao.confirmarTransicao !== undefined;
  const confirmarSeNecessario = isNecessarioConfirmacao
    ? () => setAberto(true)
    : () => submit(transicao.destino);

  const onClose = () => setAberto(false);
  const isClicada = situacaoClicada === transicao.destino;

  const isCarregando = useSelector(SolicitacaoCorrenteSelector.formulario.isCarregando)

  return <>
    <BotaoFlat
      type="button"
      tipo={transicao.tipo}
      disabled={isCarregando}
      isLoading={isClicada}
      onClick={confirmarSeNecessario}
      >
      {transicao.descricao}
    </BotaoFlat>

    <ConfirmacaoMudancaSituacaoModal isAberto={isAberto} transicao={transicao} onConfirmado={submit} onClose={onClose} />
  </>
}